import React, { useState } from "react";
import { inventoryApi } from "../services/api";
import CategorySelect from "./CategorySelect";
import "./AddItemForm.css";

export default function AddItemForm({ onAdd, onCancel }) {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("enough");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    setError(null);
    setSuccessMsg(null);
    try {
      const item = await inventoryApi.create({ name: name.trim(), category: category || null, status });
      onAdd(item);
      setName("");
      setCategory("");
      setStatus("enough");
      setSuccessMsg(`✅ "${item.name}" added!`);
      setTimeout(() => setSuccessMsg(null), 2000);
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to add item.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-form-card">
      <h2 className="add-form-title">New Item</h2>
      {error && <div className="form-error">{error}</div>}
      {successMsg && <div className="form-success">{successMsg}</div>}
      <form onSubmit={handleSubmit} className="add-form">
        <div className="form-row">
          <div className="form-group">
            <label>Item Name *</label>
            <input
              type="text"
              placeholder="e.g. Milk, Rice, Soap…"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              required
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <CategorySelect value={category} onChange={setCategory} />
          </div>
          <div className="form-group">
            <label>Initial Status</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="enough">🟢 Enough</option>
              <option value="running_low">🟡 Running Low</option>
              <option value="finished">🔴 Finished</option>
            </select>
          </div>
        </div>
        <div className="form-actions">
          <button type="button" className="btn-ghost" onClick={onCancel}>Done</button>
          <button type="submit" className="btn-primary" disabled={loading || !name.trim()}>
            {loading ? "Adding…" : "Add Item"}
          </button>
        </div>
      </form>
    </div>
  );
}
